<template>
    <div class="evaluteManager">
      <div class="managerAvator">
        <img class="avator" :src=" managerHeadpicture ? 'data:image/png;base64,' + managerHeadpicture :'/static/img/beidaziyuan/manager.jpg' " alt="">
        <p>{{name}}</p>
        <div class="managerTel">
          <span>Tel: {{tel}}</span>
          <a href="tel:17610772127"><img style="width: .4rem;height: .4rem;" src="../../../../static/img/beidaziyuan/call.png" ></a></div>
      </div>
      <div class="star">
        <div id="fiveStars">
          <div>服务态度：<img v-for="(star,index) in stars.list" :src="star.src" @click="rating(index, stars)"  /></div>
          <div>问题处理：<img v-for="(star,index) in stars1.list" :src="star.src" @click="ratingLevel(index, stars1)"  /></div>
          <div>沟通与反馈：<img v-for="(star,index) in stars2.list" :src="star.src" @click="ratingAttitude(index, stars2)"  /></div>
        </div>
      </div>
      <div class="btn">
        <input type="button" value="保存" @click="backToHomePage">
      </div>
    </div>
</template>

<script>
  //黑星星的路径
  const starOff ='../../../../static/img/beidaziyuan/wjx-old.png';
  //亮星星的路径
  const starOn='../../../../static/img/beidaziyuan/wjx-new.png';
    export default {
        name: "evaluteManager",
      data(){
          return{
            tel: '',
            name: '',
            managerHeadpicture: '',
            managerId: '',
            userId: '',
            accountCode: '',
            sysUrl: '',
            stars: {
              list: [
                {src: starOff, active: false},
                {src: starOff, active: false},
                {src: starOff, active: false},
                {src: starOff, active: false},
                {src: starOff, active: false},
              ],
              starNum:0
            },
            stars1:{
              list: [
                {src:starOff,active:false},
                {src:starOff,active:false},
                {src:starOff,active:false},
                {src:starOff,active:false},
                {src:starOff,active:false},
              ],
              starNum:0
            },
            stars2:{
              list: [
                {src:starOff,active:false},
                {src:starOff,active:false},
                {src:starOff,active:false},
                {src:starOff,active:false},
                {src:starOff,active:false},
              ],
              starNum:0 //点击星星的次数
            },
          }
      },
      mounted(){
          console.log(this.$route.params)
        this.tel = this.$route.params.managerMobile
        this.name = this.$route.params.managerName
        this.managerHeadpicture = this.$route.params.managerHeadpicture
        this.managerId = this.$route.params.managerId
        this.userId = this.$route.params.userId
        this.accountCode = this.$route.params.accountCode
        this.sysUrl = this.$route.params.sysUrl
      },
      methods:{
        //沟通与反馈
        rating(index, stars){
          let total = stars.list.length;//星星总数
          let idx = index + 1//代表应该显示的星星的数量
          if(stars.starNum ==0){ //只点了一个星星
            stars.starNum =idx
            for(var i=0;i<idx;i++){
              stars.list[i].src=starOn;
              stars.list[i].active=true;
            }
          }else{
            //如果再次点击当前选中的星级-仅取消掉当前星级，保留之前的。
            if(idx == stars.starNum){
              for(var i=idx;i<total;i++){
                stars.list[i].src=starOff;
                stars.list[i].active=false;
              }
            }
            //如果小于当前最高星级，则直接保留当前星级
            if(idx <stars.starNum){
              for(var i=idx;i<stars.starNum;i++){
                stars.list[i].src=starOff;
                stars.list[i].active=false;
              }
            }
            //如果大于当前星级，则直接选到该星级
            if(idx > stars.starNum){
              for(var i=0;i<idx;i++){
                stars.list[i].src=starOn;
                stars.list[i].active=true;
              }
            }
            let count =0;//当前几颗星
            for(var i=0;i<total;i++){
              if(stars.list[i].active){
                count++;
              }
            }
            stars.starNum =count;
            console.log(stars.starNum)
          }
        },
        //服务态度问题处理
        ratingLevel(index, stars){
          let total = stars.list.length;//星星总数
          let idx = index + 1//代表应该显示的星星的数量
          if(stars.starNum ==0){  //只点了一个星星
            stars.starNum =idx
            for(var i=0;i<idx;i++){
              stars.list[i].src=starOn;
              stars.list[i].active=true;
            }
          }else{
            //如果再次点击当前选中的星级-仅取消掉当前星级，保留之前的。
            if(idx == stars.starNum){
              for(var i=idx;i<total;i++){
                stars.list[i].src=starOff;
                stars.list[i].active=false;
              }
            }
            //如果小于当前最高星级，则直接保留当前星级
            if(idx <stars.starNum){
              for(var i=idx;i<stars.starNum;i++){
                stars.list[i].src=starOff;
                stars.list[i].active=false;
              }
            }
            //如果大于当前星级，则直接选到该星级
            if(idx > stars.starNum){
              for(var i=0;i<idx;i++){
                stars.list[i].src=starOn;
                stars.list[i].active=true;
              }
            }
            let count =0;//当前几颗星
            for(var i=0;i<total;i++){
              if(stars.list[i].active){
                count++;
              }
            }
            stars.starNum =count;
            console.log(stars.starNum)
          }
        },
        // 沟通与反馈
        ratingAttitude(index, stars){
          let total = stars.list.length;//星星总数
          let idx = index + 1//代表应该显示的星星的数量
          if(stars.starNum ==0){  //只点了一个星星
            stars.starNum =idx
            for(var i=0;i<idx;i++){
              stars.list[i].src=starOn;
              stars.list[i].active=true;
            }
          }else{
            //如果再次点击当前选中的星级-仅取消掉当前星级，保留之前的。
            if(idx == stars.starNum){
              for(var i=idx;i<total;i++){
                stars.list[i].src=starOff;
                stars.list[i].active=false;
              }
            }
            //如果小于当前最高星级，则直接保留当前星级
            if(idx <stars.starNum){
              for(var i=idx;i<stars.starNum;i++){
                stars.list[i].src=starOff;
                stars.list[i].active=false;
              }
            }
            //如果大于当前星级，则直接选到该星级
            if(idx > stars.starNum){
              for(var i=0;i<idx;i++){
                stars.list[i].src=starOn;
                stars.list[i].active=true;
              }
            }
            let count =0;//当前几颗星
            for(var i=0;i<total;i++){
              if(stars.list[i].active){
                count++;
              }
            }
            stars.starNum =count;
            console.log(stars.starNum)
          }
        },
        //保存之后返回首页
        backToHomePage(){
          let _this = this;
          if(_this.stars.starNum === 0 || _this.stars1.starNum === 0 || _this.stars2.starNum === 0){
              alert('请填写完整评论！')
          }else{
            // _this.postRequest('phoneServer/wechat/addHouseManagerEvaluation',{
            _this.postRequestN9( _this.sysUrl+ '/LsInterfaceServer/phoneServer/wechat/addHouseManagerEvaluation',{
              userid: _this.userId, //待定
              accountcode: _this.accountCode,
              serviceattitude: _this.stars.starNum, //服务态度
              majorlevel: _this.stars1.starNum, //问题处理
              linkagefeedback: _this.stars2.starNum, //沟通予反馈
              pk_manager: _this.managerId,
            },function (data) {
              console.log(data)
              _this.$router.push('homePageBeiDaZiYuan')
              alert('评价成功！')
            })
          }
        }
      }
    }
</script>

<style scoped>
  .evaluteManager{
    padding-top: 1rem;
    box-sizing: border-box;
  }
  .managerAvator p{
    height: .8rem;
    line-height: .8rem;
  }
  .btn input{
    width: 90%;
    height: 1rem;
    color: #fff;
    font-size: .5rem;
    border-radius: .5rem;
    background-color: #F7B632;
  }
  .avator{
    width: 3rem;
    height: 3rem;
    border-radius: 200%;
  }
  #fiveStars{
    margin: 1rem auto;
  }
  #fiveStars div{
    font-size:30px;
    text-align: center;
    line-height: 60px;
  }
  #fiveStars img{
    width:40px;
    margin-right: 10px;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/pub-component/myManager/evaluteManager.vue